import type { Page } from "./catalog/types";

// CRA inlines process.env.PUBLIC_URL at build time if the PUBLIC_URL env var is
// set; the deploy workflow doesn't set it, so this falls back to the browser's
// current origin (https://baldai.kz in production) at runtime.
export function getSiteOrigin(): string {
  if (process.env.PUBLIC_URL) {
    return process.env.PUBLIC_URL;
  }
  return typeof window !== "undefined" ? window.location.origin : "";
}

export function pageToAbsoluteUrl(page: Page): string {
  return `${getSiteOrigin()}${BALDAI_ROUTE_PATHS[page]}`;
}

export const BALDAI_ROUTE_PATHS: Record<Page, string> = {
  home: "/",
  sets: "/sets",
  partners: "/partners",
  contacts: "/contacts"
};

const PATH_TO_PAGE: Record<string, Page> = Object.entries(BALDAI_ROUTE_PATHS).reduce(
  (accumulator, [page, path]) => {
    accumulator[path] = page as Page;
    return accumulator;
  },
  {} as Record<string, Page>
);

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function pageToPath(page: Page): string {
  return BALDAI_ROUTE_PATHS[page];
}

export function pathnameToPage(pathname: string): Page {
  const normalizedPathname = normalizePathname(pathname);
  return PATH_TO_PAGE[normalizedPathname] ?? "home";
}
